<template>
  <div class="theme">
    
    <!-- <div style="height: 17rem;">
      <div class="carousel">
        <a-carousel>
          <div v-for="item in bannerImg" :key="item.id" style="height: 17rem;">
            <img style="object-fit: cover;" :src="imgPrefix + item.pic" alt="" />
          </div>
        </a-carousel>
      </div>
      <div
        class="w flex"
        style="justify-content: space-between; align-items: normal"
      >
        <div class="ban_l">
          <div class="tit">
            主题专区
            <img
              style="padding-bottom: 8px"
              src="../../assets/theme-zi.png"
              alt=""
            />
          </div>
          <div class="desc">
            业务主题集合专区，推进“一门式、一网式”校务服务模式，让师生少跑腿、好办事、办好一件事。
          </div>
        </div>
      </div>
    </div> -->

    <Carousel :bannerImg="bannerImg" :bannerInfo="bannerInfo" />

    <div class="w theme_ti flex">
      <div class="title">
        报修一件事 <span class="total">共{{ total }}项</span>
      </div>
      <div class="search_box">
        <a-input-search
          style="width: 299px"
          enter-button
          :allowClear="true"
          placeholder="请输入你要查询的关键字..."
          @search="onSearch"
        />
      </div>
    </div>
    <div style="margin: -1rem">
      <div class="w box_big clearfix">
        <div
          v-for="(item, index) in featureData"
          :key="index"
          style="margin: -1rem"
        >
          <div class="swiper_box fl" @click="checkDetails(item)">
            <div class="hover">
              <img :src="imgPrefix + item.card" alt="图片" />
              <div class="swiper_con">
                <div class="swiper_tit" style="margin-bottom: 12px">
                  {{ item.name }}
                </div>
                <div class="swiper_clamp">{{ item.introduction }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-pagination
        v-model="page"
        class="w"
        :defaultPageSize="defaultPageSize"
        :total="total"
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import imgPrefix from "../../../utils/imgPrefix";
import { findThemeByKeywordApi, findNavBannerApi, findUnionByKeywordApi } from "@/api/index";
import Carousel from '../../components/Carousel.vue';
export default {
  components: {Carousel},
  data() {
    return {
      page: 1,
      pageSize: 8,
      defaultPageSize:8,
      featureData: [],
      keyword: "",
      total: 0,
      imgPrefix,
      current: 1,
      bannerImg: [],
      bannerInfo:{
        title:'主题专区',
        desc:'业务主题集合专区，推进“一门式、一网式”校务服务模式，让师生少跑腿、好办事、办好一件事。'
      }
    };
  },
  created() {
    this.getFindThemeByKeyword();
    this.getBanner();
  },
  methods: {
    // 获取专区列表
    getFindThemeByKeyword() {
      let dto = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword,
      };
      findUnionByKeywordApi(dto)
        .then((res) => {
          // console.log(res);
          this.total = res.pageListVo.total;
          this.page = res.pageListVo.page;
          this.featureData = res.pageListVo.list;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取banner
    getBanner() {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach(item => {
        if (item.link == "/theme") {
          findNavBannerApi(item.id)
            .then((res) => {
              // console.log(res);
              this.bannerImg = res;
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      });
    },
    onSearch(e) {
      // console.log(e);
      this.page = 1;
      this.keyword = e;
      this.getFindThemeByKeyword();
    },
    checkDetails(e) {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach(item => {
        if (item.link == "/theme") {
          this.$router.push("/themeDetails?themeId=" + e.id + "&naviId=" + item.id);
        }
      });
    },
    // 切换页码
    pageChange(page, pageSize) {
      // this.current = page;
      this.page = page;
      this.getFindThemeByKeyword()
    },
  },
};
</script>

<style lang="less" scoped>
.theme {
  position: relative;
  .title {
    font-weight: 700;
    font-size: 32px;
    color: #0d1c28;
    text-align: left;
    .total {
      font-size: 18px;
      color: #7a8ba4;
      font-weight: 400;
    }
  }
  .theme_ti {
    justify-content: space-between;
    padding: 42px 0;
    position: relative;
    .search_box{
      position: absolute;
      right: 0;
      top: -118px;
    }
  }
  .swiper_box {
    margin-right: 0;
    cursor: pointer;
    width: 25%;
    padding: 1rem;
    .hover {
      height: 16.625rem;
      transition: all 0.3s ease;
      box-shadow: 0px 3px 20px rgba(9, 41, 77, 0.1);
      // width: 278px;
    }
    img {
      width: 100%;
      height: 8.75rem;
    }
    .swiper_con {
      padding: 24px;
      text-align: left;
      .swiper_tit {
        font-size: 16px;
        color: #0d1c28;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .swiper_clamp {
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #7a8ba4;
        font-size: 14px;
      }
    }
  }
  .hover:hover {
    transition: all 0.3s ease;
    // background: #1890ff;
    background: var(--themeColor6);
    transform: translate3d(0, -0.3rem, 0);
    .swiper_tit,
    .swiper_clamp {
      color: #fff;
    }
  }
  .swiper_box:not(:nth-child(4n)) {
    // margin-right: calc(10% / 4);
  }
}

/deep/.ant-btn-primary {
  background: var(--themeSloganColor);
  border: none;
}
/deep/.ant-pagination {
  margin: 0 auto;
  padding-bottom: 85px;
  text-align: right;
}
</style>
